import React from 'react';
import { NavLink } from 'react-router-dom';
export const Link = React.forwardRef(({ external, to, children, style, disabled }, ref) => {
    return external ? (React.createElement("a", { target: '_blank', href: disabled ? '#' : to, rel: 'noreferrer', ref: ref, style: style, tabIndex: -1 }, children)) : (React.createElement(NavLink, { to: disabled ? '#' : to, ref: ref, style: style, tabIndex: -1 }, children));
});
Link.displayName = 'Link';
//# sourceMappingURL=index.js.map